import { useCallback, useState } from 'react';
import { DetailsPanel, EditIcon, IconButton, PrimaryButton, Table, Typography } from '@weareopenr/component-library';
import VenueChannelsEditModal from 'src/components/VenueChannelsEditModal';
import { channelColumns, mapChannelsToTable } from './mapChannelsToTable/mapChannelsToTable';
import { IChannel, IVenue } from 'src/types/venue.types';
import { IAggregator } from 'src/types/aggregator.types';
import styles from './VenueChannels.module.scss';

interface IEmptyStateProps {
  onAddChannels: () => void;
}

const EmptyState = ({ onAddChannels }: IEmptyStateProps) => (
  <div className={styles['no-channels']}>
    <Typography>No Channels currently configured</Typography>
    <PrimaryButton onClick={onAddChannels}>Add Channels</PrimaryButton>
  </div>
);

export interface IVenueChannels {
  venue: IVenue;
  channels: IChannel[];
  aggregators: IAggregator[];
}

const VenueChannels = ({ venue, channels, aggregators }: IVenueChannels) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const handleModalClick = () => setIsModalOpen((prev: boolean) => !prev);
  const renderEmptyState = useCallback(() => <EmptyState onAddChannels={handleModalClick} />, [handleModalClick]);

  return (
    <>
      <DetailsPanel
        title="Channels"
        action={
          <IconButton buttonStyle="ghost" onClick={handleModalClick} icon={EditIcon} aria-label="Edit channels" />
        }
      >
        <div>
          <Table data={mapChannelsToTable(channels)} columns={channelColumns} EmptyState={renderEmptyState} />
        </div>
      </DetailsPanel>
      <VenueChannelsEditModal
        isModalOpen={isModalOpen}
        onModalClose={handleModalClick}
        venue={venue}
        aggregators={aggregators}
      />
    </>
  );
};

export default VenueChannels;
